import React, { createContext, useContext, useState, useEffect } from "react";

// Create the context
const RoleContext = createContext();

// Custom hook to use the RoleContext
export const useRole = () => {
  return useContext(RoleContext);
};

// RoleProvider component that provides the context to the children
export const RoleProvider = ({ children }) => {
  const [role, setRole] = useState(null); // Initialize role state
  const [permission, setPermission] = useState([]);
  const [userDetails, setUserDetails] = useState([]);

  // Log the state whenever it updates
  useEffect(() => {
    // console.log("Role Permission:", permission);
  }, [permission]); // Dependency array to run this effect when 'role' changes

  return (
    <RoleContext.Provider
      value={{
        role,
        setRole,
        setPermission,
        permission,
        setUserDetails,
        userDetails,
      }}
    >
      {children} {/* Render the child components */}
    </RoleContext.Provider>
  );
};
